import React from "react";
import Fade from "react-reveal";

const Footer = (props) => {
    if (!props.data) return null;

    return (
      <footer>
        <div className="row">
          <Fade bottom>
            <div className="twelve columns">
              <h4 className= "footer-text">НОИТ 2022 | Проект №546 | Уеб сайт | Мария Малчева, 9б и Симеон Теремков, 10б | <a href='https://pgi-pernik.bg-schools.com/' target="_blank">ПГИ - гр. Перник</a></h4>
            </div>
          </Fade>

          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
}

export default Footer;
